// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__1pOq0"};